import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
import { useGroups } from 'root/src/client/v2/auth/hooks/useGroups';
export function useIsAdmin() {
    const { groups } = useGroups();
    return {
        isAdmin: groups.includes(AuthGroup.Admin) || groups.includes(AuthGroup.SuperAdmin),
    };
}
